module.exports = __webpack_public_path__ + "img/03j_Store_651.501339aa.jpg";